import { ChartArea, Megaphone, PiggyBank } from "lucide-react";

import { routes } from "@redwoodjs/router";

import {
  analyticsPages,
  financePages,
  marketingPages,
} from "src/lib/constants";

export const sidebarFrequentlyUsedSeedIds = ["unitEconomics", "normalizedPL"];

const getRoute = (routeName, params, fallbackUrl) => {
  const route = routes[routeName];

  return typeof route === "function" ? route(params) : fallbackUrl;
};

const getPageUrl = (section, pageId) => {
  switch (section) {
    case "analytics":
      return getRoute("analytics", { child: pageId }, `/analytics/${pageId}`);
    case "finance":
      return getRoute("finance", { child: pageId }, `/finance/${pageId}`);
    case "marketing":
      return getRoute("marketing", { child: pageId }, `/marketing/${pageId}`);
    default:
      return "#";
  }
};

const createSidebarPage = (page, section, icon) => ({
  icon,
  id: page.id,
  name: page.name,
  section,
  url: getPageUrl(section, page.id),
});

export const sidebarReportPages = [
  ...Object.values(analyticsPages).map((page) =>
    createSidebarPage(page, "analytics", ChartArea)
  ),
  ...Object.values(financePages).map((page) =>
    createSidebarPage(page, "finance", PiggyBank)
  ),
  ...Object.values(marketingPages).map((page) =>
    createSidebarPage(page, "marketing", Megaphone)
  ),
];

export const sidebarReportPageById = Object.fromEntries(
  sidebarReportPages.map((page) => [page.id, page])
);
